var styles = {
  "Grid": "pb-Grid__Grid",
  "Row": "pb-Grid__Row",
  "Cell": "pb-Grid__Cell",
  "size-1": "pb-Grid__size-1",
  "size-2": "pb-Grid__size-2",
  "size-3": "pb-Grid__size-3",
  "size-4": "pb-Grid__size-4",
  "size-5": "pb-Grid__size-5",
  "size-6": "pb-Grid__size-6",
  "size-7": "pb-Grid__size-7",
  "size-8": "pb-Grid__size-8",
  "size-9": "pb-Grid__size-9",
  "size-10": "pb-Grid__size-10",
  "size-11": "pb-Grid__size-11",
  "size-12": "pb-Grid__size-12",
  "offset-1": "pb-Grid__offset-1",
  "offset-2": "pb-Grid__offset-2",
  "offset-3": "pb-Grid__offset-3",
  "offset-4": "pb-Grid__offset-4",
  "offset-5": "pb-Grid__offset-5",
  "offset-6": "pb-Grid__offset-6",
  "offset-7": "pb-Grid__offset-7",
  "offset-8": "pb-Grid__offset-8",
  "offset-9": "pb-Grid__offset-9",
  "offset-10": "pb-Grid__offset-10",
  "offset-11": "pb-Grid__offset-11",
  "sizeMedium-1": "pb-Grid__sizeMedium-1",
  "sizeMedium-2": "pb-Grid__sizeMedium-2",
  "sizeMedium-3": "pb-Grid__sizeMedium-3",
  "sizeMedium-4": "pb-Grid__sizeMedium-4",
  "sizeMedium-5": "pb-Grid__sizeMedium-5",
  "sizeMedium-6": "pb-Grid__sizeMedium-6",
  "sizeMedium-7": "pb-Grid__sizeMedium-7",
  "sizeMedium-8": "pb-Grid__sizeMedium-8",
  "sizeMedium-9": "pb-Grid__sizeMedium-9",
  "sizeMedium-10": "pb-Grid__sizeMedium-10",
  "sizeMedium-11": "pb-Grid__sizeMedium-11",
  "sizeMedium-12": "pb-Grid__sizeMedium-12",
  "offsetMedium-1": "pb-Grid__offsetMedium-1",
  "offsetMedium-2": "pb-Grid__offsetMedium-2",
  "offsetMedium-3": "pb-Grid__offsetMedium-3",
  "offsetMedium-4": "pb-Grid__offsetMedium-4",
  "offsetMedium-5": "pb-Grid__offsetMedium-5",
  "offsetMedium-6": "pb-Grid__offsetMedium-6",
  "offsetMedium-7": "pb-Grid__offsetMedium-7",
  "offsetMedium-8": "pb-Grid__offsetMedium-8",
  "offsetMedium-9": "pb-Grid__offsetMedium-9",
  "offsetMedium-10": "pb-Grid__offsetMedium-10",
  "offsetMedium-11": "pb-Grid__offsetMedium-11",
  "sizeLarge-1": "pb-Grid__sizeLarge-1",
  "sizeLarge-2": "pb-Grid__sizeLarge-2",
  "sizeLarge-3": "pb-Grid__sizeLarge-3",
  "sizeLarge-4": "pb-Grid__sizeLarge-4",
  "sizeLarge-5": "pb-Grid__sizeLarge-5",
  "sizeLarge-6": "pb-Grid__sizeLarge-6",
  "sizeLarge-7": "pb-Grid__sizeLarge-7",
  "sizeLarge-8": "pb-Grid__sizeLarge-8",
  "sizeLarge-9": "pb-Grid__sizeLarge-9",
  "sizeLarge-10": "pb-Grid__sizeLarge-10",
  "sizeLarge-11": "pb-Grid__sizeLarge-11",
  "sizeLarge-12": "pb-Grid__sizeLarge-12",
  "offsetLarge-1": "pb-Grid__offsetLarge-1",
  "offsetLarge-2": "pb-Grid__offsetLarge-2",
  "offsetLarge-3": "pb-Grid__offsetLarge-3",
  "offsetLarge-4": "pb-Grid__offsetLarge-4",
  "offsetLarge-5": "pb-Grid__offsetLarge-5",
  "offsetLarge-6": "pb-Grid__offsetLarge-6",
  "offsetLarge-7": "pb-Grid__offsetLarge-7",
  "offsetLarge-8": "pb-Grid__offsetLarge-8",
  "offsetLarge-9": "pb-Grid__offsetLarge-9",
  "offsetLarge-10": "pb-Grid__offsetLarge-10",
  "offsetLarge-11": "pb-Grid__offsetLarge-11"
};
export default styles;